import React from 'react';
import { Box, Typography, TextField, Switch, FormControlLabel, Alert, Paper, Divider } from '@mui/material';
import TeamFollowUpReminderButtons from 'team/components/editMember/followUpEmail/TeamFollowUpReminderButtons';

const TeamInviteEmailsForm = ({
    subject,
    setSubject,
    message,
    setMessage,
    callToAction,
    setCallToAction,
    showTouchInfo,
    setShowTouchInfo,
    loading,
    disabled,
    successMessage,
    errorMessage,
    onUpdate,
    onCancel
}) => {
    return (
        <Paper elevation={0} sx={{ p: 4, borderRadius: 2, backgroundColor: 'white', maxWidth: '800px', mx: 'auto' }}>
            <Box sx={{ mb: 4 }}>
                <Typography variant="h5" fontWeight="bold" sx={{ mb: 1 }}>
                    Customize Invite Email
                </Typography>
                <Typography variant="body2" color="text.secondary">
                    Customize the email sent to new team members.
                </Typography>
            </Box>

            {successMessage && <Alert severity="success" sx={{ mb: 3 }}>{successMessage}</Alert>}
            {errorMessage && <Alert severity="error" sx={{ mb: 3 }}>{errorMessage}</Alert>}

            <Box component="form" noValidate autoComplete="off">
                {/* To Field (Locked) */}
                <Box sx={{ mb: 3 }}>
                    <Typography variant="subtitle2" fontWeight="bold" sx={{ mb: 1 }}>
                        To:
                    </Typography>
                    <TextField
                        fullWidth
                        value="{Invite Member}"
                        disabled
                        variant="outlined"
                        size="small"
                        sx={{ backgroundColor: '#f5f5f5' }}
                    />
                    <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5, display: 'block' }}>
                        Locked variable
                    </Typography>
                </Box>

                {/* Subject Field */}
                <Box sx={{ mb: 3 }}>
                    <Typography variant="subtitle2" fontWeight="bold" sx={{ mb: 1 }}>
                        Subject *
                    </Typography>
                    <TextField
                        fullWidth
                        value={subject}
                        onChange={(e) => setSubject(e.target.value)}
                        variant="outlined"
                        size="small"
                        placeholder="[Action Required] You have been invited to Touch Teams"
                    />
                </Box>

                {/* Message Field */}
                <Box sx={{ mb: 3 }}>
                    <Typography variant="subtitle2" fontWeight="bold" sx={{ mb: 1 }}>
                        Message
                    </Typography>
                    <TextField
                        fullWidth
                        multiline
                        rows={6}
                        value={message}
                        onChange={(e) => setMessage(e.target.value)}
                        variant="outlined"
                        placeholder="Enter your custom message here..."
                        helperText="Variables available: {firstName}, {teamName}, {inviterName}"
                    />
                </Box>

                {/* Call To Action Field */}
                <Box sx={{ mb: 3 }}>
                    <Typography variant="subtitle2" fontWeight="bold" sx={{ mb: 1 }}>
                        Call To Action *
                    </Typography>
                    <TextField
                        fullWidth
                        value={callToAction}
                        onChange={(e) => setCallToAction(e.target.value)}
                        variant="outlined"
                        size="small"
                        placeholder="Join Now"
                    />
                </Box>

                {/* Touch Information Toggle */}
                <Box sx={{ mb: 4 }}>
                    <Typography variant="subtitle2" fontWeight="bold" sx={{ mb: 1 }}>
                        Touch Information
                    </Typography>
                    <FormControlLabel
                        control={
                            <Switch
                                checked={!showTouchInfo}
                                onChange={(e) => setShowTouchInfo(!e.target.checked)}
                                color="primary"
                            />
                        }
                        label="Remove additional Touch information from bottom of the email"
                    />
                </Box>

                <Divider sx={{ mb: 3 }} />

                {/* Buttons */}
                <TeamFollowUpReminderButtons
                    onUpdate={onUpdate}
                    onCancel={onCancel}
                    disabled={loading || disabled}
                    // Test email function explicitly disabled/hidden logic can be handled inside the button component or by passing empty function if needed.
                    onSendTest={() => { }}
                />
            </Box>
        </Paper>
    );
};

export default TeamInviteEmailsForm;
